import PropTypes from "prop-types";
import { formatDateTime } from "@helpers/date";
import { KYC_LABEL } from "@src/utility/constants/panel/common";
import { TIMELINE_EMPTY_NOTE } from "../misc/constants";

// Who moved the status and when. The rail is drawn on the <li> rather than the
// list so the last entry's line stops at its own dot.
const KycTimeline = ({ timeline }) => {
    if (timeline.length === 0) {
        return <p className="mt-3 text-sm text-muted">{TIMELINE_EMPTY_NOTE}</p>;
    }

    return (
        <ol className="mt-3">
            {timeline.map((entry, idx) => (
                <li key={entry._id} className="relative flex gap-3 pb-4 last:pb-0">
                    {idx < timeline.length - 1 && (
                        <span aria-hidden="true" className="absolute left-[3px] top-3 h-full w-px bg-gray-200" />
                    )}
                    <span className="relative mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
                    <div className="min-w-0">
                        <p className="text-sm font-medium text-gray-900">{KYC_LABEL[entry.status] || entry.status}</p>
                        <p className="text-xs text-muted">
                            {formatDateTime(entry.createdAt)}
                            {entry.changed_by?.role && ` · ${entry.changed_by.role}`}
                            {entry.changed_by?.name && ` · ${entry.changed_by.name}`}
                        </p>
                    </div>
                </li>
            ))}
        </ol>
    );
};

KycTimeline.propTypes = {
    timeline: PropTypes.array.isRequired
};

export default KycTimeline;
